import React from 'react';
import { Card, Col, Row, Tag, Typography, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccStatusBoard } from '@/hooks/useWorkstationControlCenter';

const CARD_STATUS_COLOR: Record<string, string> = {
  Running: 'success',
  Waiting: 'warning',
  Blocked: 'error',
  Setup: 'processing',
  Idle: 'default',
  Maintenance: 'purple',
};

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const WorkstationStatusBoard: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccStatusBoard(params);
  const cards = (data as { cards?: Record<string, unknown>[] })?.cards ?? [];

  if (isLoading) return <Spin />;

  return (
    <div id="status-board" style={{ marginTop: 16 }}>
      <Typography.Title level={5}>Real-time workstation status</Typography.Title>
      <Row gutter={[12, 12]}>
        {cards.map((c) => (
          <Col xs={24} sm={12} md={8} lg={6} key={String(c.workstation_id)}>
            <Card
              size="small"
              hoverable
              onClick={() =>
                navigate(`/mfg/work-order-operations?workstationId=${c.workstation_id}`)
              }
              title={
                <span>
                  {String(c.workstation_code)} — {String(c.workstation_name)}
                </span>
              }
              extra={
                <Tag color={CARD_STATUS_COLOR[String(c.card_status)] || 'default'}>
                  {String(c.card_status)}
                </Tag>
              }
            >
              <div>{c.department ? `Dept: ${c.department}` : null}</div>
              <div>Op: {String(c.current_operation || '—')}</div>
              <div>WO: {String(c.current_work_order_number || '—')}</div>
              <div>Operator: {String(c.operator_name || '—')}</div>
              <div>Queue: {String(c.queue_count)}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default WorkstationStatusBoard;
